const sortData = (data, sortConfig) => {
  if (!Array.isArray(data)) return [];

  const temp = [...data];

  if (!sortConfig?.key) return temp;

  return temp.sort((a, b) => {
    const valA = a[sortConfig.key];
    const valB = b[sortConfig.key];

    if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
    if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });
};

export default sortData;